import { useEffect, useMemo } from 'react';
import throttle from 'lodash/throttle';
export const useHandleResize = ({ ref }) => {
    const onResize = useMemo(() => {
        return throttle(() => {
            if (ref.current) {
                const parent = ref.current.parentElement;
                const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
                ref.current.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
                ref.current.style.setProperty('--parent-width', `${parent.clientWidth}px`);
            }
        }, 100);
    }, [ref]);
    /**
     * Get the parent element set the width of it as css variable
     * Throttle the resize event to prevent performance issues
     * Also set the scrollbar width as css variable
     */
    useEffect(() => {
        window.addEventListener('resize', onResize);
        onResize();
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, [onResize]);
};
